import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=378706d0&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378706d0",
  null
  
)

export default component.exports